import revive_payload_client_4sVQNw7RlN from "/app/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import unhead_KgADcZ0jPj from "/app/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import router_jmwsqit4Rs from "/app/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "/app/node_modules/nuxt/dist/app/plugins/payload.client.js";
import check_outdated_build_client_8vK7RkfGxZ from "/app/node_modules/nuxt/dist/app/plugins/check-outdated-build.client.js";
import plugin_vue3_A0OWXRrUgq from "/app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/app/.nuxt/components.plugin.mjs";
import prefetch_client_5tzzN0oIVL from "/app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import sentry_client_VdOeuw25Mb from "/app/node_modules/@sentry/nuxt/build/module/runtime/plugins/sentry.client.js";
import sentry_client_config_o34nk2sJbg from "/app/.nuxt/sentry-client-config.mjs";
import switch_locale_path_ssr_5csfIgkrBP from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/switch-locale-path-ssr.js";
import i18n_sq1MuCrqbC from "/app/node_modules/@nuxtjs/i18n/dist/runtime/plugins/i18n.js";
import plugin_ucMK8VhJjR from "/app/node_modules/nuxt-easy-lightbox/dist/runtime/plugin.mjs";
import plugin_t2GMTTFnMT from "/app/node_modules/@nuxtjs/device/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "/app/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import index_kyvreQaQna from "/app/plugins/vuetify/index.ts";
import index_pJsEXjjc09 from "/app/plugins/iconify/index.ts";
import api_GFfDXud5Cr from "/app/plugins/api.ts";
import google_analytics_client_KruZkwwzId from "/app/plugins/google-analytics.client.ts";
import gtm_client_OzmBuHLRIb from "/app/plugins/gtm.client.ts";
import html2pdf_client_CnElePg9y5 from "/app/plugins/html2pdf.client.ts";
import layouts_mPotmY5lsV from "/app/plugins/layouts.ts";
import recaptcha_client_ElRG0N5AcO from "/app/plugins/recaptcha.client.ts";
import vue_datepicker_dyozMmv23j from "/app/plugins/vue-datepicker.ts";
import vue3_google_login_client_U3nJLmd4lD from "/app/plugins/vue3-google-login.client.ts";
export default [
  revive_payload_client_4sVQNw7RlN,
  unhead_KgADcZ0jPj,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  check_outdated_build_client_8vK7RkfGxZ,
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  prefetch_client_5tzzN0oIVL,
  sentry_client_VdOeuw25Mb,
  sentry_client_config_o34nk2sJbg,
  switch_locale_path_ssr_5csfIgkrBP,
  i18n_sq1MuCrqbC,
  plugin_ucMK8VhJjR,
  plugin_t2GMTTFnMT,
  chunk_reload_client_UciE0i6zes,
  index_kyvreQaQna,
  index_pJsEXjjc09,
  api_GFfDXud5Cr,
  google_analytics_client_KruZkwwzId,
  gtm_client_OzmBuHLRIb,
  html2pdf_client_CnElePg9y5,
  layouts_mPotmY5lsV,
  recaptcha_client_ElRG0N5AcO,
  vue_datepicker_dyozMmv23j,
  vue3_google_login_client_U3nJLmd4lD
]